import { Client } from '@utilities/types';
import React, { createContext, useState, PropsWithChildren } from 'react';
interface ClientContextType {
    clients: Client[];
    setClients: React.Dispatch<React.SetStateAction<Client[]>>;
    selectedClient: Client | null;
    setSelectedClient: React.Dispatch<React.SetStateAction<Client | null>>;
}

export const ClientContext = createContext<ClientContextType>({
    clients: [],
    setClients: () => { },
    selectedClient: null,
    setSelectedClient: () => { }
});

export const ClientContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    
    const [clients, setClients] = useState<Client[]>([]);
    const [selectedClient, setSelectedClient] = useState<Client | null>(null);

    return (
        <ClientContext.Provider value={{
            clients,
            setClients,
            selectedClient,
            setSelectedClient
        }}>
            {children}
        </ClientContext.Provider>
    );
};
